import ButtonLink from "@/components/ButtonLink";
import { useTranslation } from "react-i18next";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/amplitude";
import { useEffect, useRef } from "react";

export default function ReviewRejected() {
  const { t } = useTranslation();
  const hasTrackedPageView = useRef(false);
  const placeRef = window.localStorage.getItem("placeRef");

  useEffect(() => {
    if (!hasTrackedPageView.current) {
      hasTrackedPageView.current = true;
      trackEvent("review_rejected_page_viewed", { placeRef });
    }
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="mx-auto flex min-h-[100dvh] w-full max-w-md grow flex-col px-6">
        <div className="flex grow flex-col items-center justify-center pb-20">
          <div className="flex w-full animate-slideUp flex-col items-center gap-8">
            {/* Error Icon */}
            <div className="relative">
              <div className="flex h-24 w-24 items-center justify-center rounded-full bg-light-gray/30">
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-light-gray">
                  <svg
                    className="h-12 w-12 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M6 6l12 12M18 6l-12 12"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="flex flex-col items-center gap-4">
              <h1 className="text-center text-3xl font-bold text-foreground">
                {t("coupon.review-rejected.title")}
              </h1>
            </div>

            {/* Info Card */}
            <div className="w-full space-y-12 rounded-3xl border border-light-gray bg-medium-gray px-8 py-12">
              <div className="space-y-4">
                <p className="text-center leading-relaxed text-white">
                  {t("coupon.review-rejected.description")}
                </p>
              </div>

              <Link
                to="/guidelines"
                className="flex w-full items-center justify-between"
                onClick={() =>
                  trackEvent("guidelines_clicked", {
                    placeRef,
                    source: "review_rejected_page",
                  })
                }
              >
                <span>{t("upload-video.inputs.guidelines")}</span>
                <FaChevronRight />
              </Link>
            </div>

            {/* CTA Button */}
            <ButtonLink
              to="/upload"
              className="w-full"
              onClick={() => trackEvent("retry_upload_clicked", { placeRef })}
            >
              {t("coupon.review-rejected.button")}
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
}
